module.exports = __webpack_public_path__ + "76481cf550e4750b105cd1dead4a60cb.svg";